<template>
  <div class="banner banner--columned">
    <div class="container">
      <div
        :style="{
          'background-image': `url(${background})`
        }"
        class="banner__content rounded-10"
      >
        <div class="row flex-row align-items-center">
          <div class="col-md-9 col--content">
            <h1 class="banner__title">{{ title }}</h1>
            <div v-if="subtitle" class="banner__subtitle">
              {{ subtitle }}
            </div>
          </div>
          <div class="col-md-3 col--content">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    background: {
      type: String,
      default: require("@/assets/media/backgrounds/banner-default@2x.png")
    }
  }
};
</script>

<style lang="scss" scoped>
@import "node_modules/bootstrap/scss/mixins/_breakpoints.scss";

.rounded {
  border-radius: 0;

  @include media-breakpoint-up(md) {
    border-radius: 0.375rem !important;
  }
}

.banner {
  margin-bottom: 1.5rem;

  @include media-breakpoint-up(md) {
    margin-bottom: 2.5rem;
  }

  &__status {
    text-align: center;

    &-label {
      display: inline-block;
      font-size: 20px;
      line-height: 1em;
      margin-bottom: 3px;
      /* span { */
      background-color: $highlight;
      border-radius: 6px;
      color: $highlight-text;
      padding: 15px 25px;
      /* } */
    }

    &-link {
      display: inline-block;
      font-size: 13px;
      @include media-breakpoint-down(sm) {
        display: block;
      }
    }
    @include media-breakpoint-down(sm) {
      margin-top: 10px;
      text-align: left;
    }
  }
  &__content {
    background-color: #fdfdfd;
    background-position: 75%;
    background-repeat: no-repeat;
    background-size: auto 100%;
    display: flex;
    flex-flow: column wrap;
    width: 100%;
    height: 9.375rem;
    justify-content: center;
    padding: 1rem;
    position: relative;

    @include media-breakpoint-up(md) {
      background-position: 75% 50%;
      padding: 1rem 3.75rem;
    }

    @include media-breakpoint-up(lg) {
      background-position: 100% 50%;
    }
  }

  &__title {
    font-size: 1.5rem;
    margin: 0;

    @include media-breakpoint-up(md) {
      font-size: 1.875rem;
    }
  }

  &__subtitle {
    font-size: 1.125rem;
    font-weight: 300;
    line-height: 1.15;

    @include media-breakpoint-up(md) {
      font-size: 1.5rem;
    }
  }
}

.banner.banner--columned {
  .col--content {
    &:nth-child(1) {
      margin-bottom: 15px;
    }
    &:last-child {
      text-align: right;
      @include media-breakpoint-down(md) {
        text-align: left;
      }
    }
  }
}
</style>
